<style lang="less" scoped>
  .custom-loading-style {
    background: rgba(0, 0, 0, 0);
    overflow: hidden;
  }
</style>

<template>
  <van-popup class="custom-loading-style"
             :overlay-style="overlayStyle"
             :value="loading"
             :close-on-popstate="true"
             :close-on-click-overlay="false"
             :closeable="false">
    <van-loading :color="color"
                 :type="type"
                 :size="size"
                 :text-size="textSize"
                 :text-color="textColor"
                 :vertical="vertical">
      <slot/>
    </van-loading>
  </van-popup>
</template>

<script>
  export default {
    name: 'CustomLoading',
    props: {
      loading: {
        type: Boolean,
        default: false
      },
      color: {
        type: String,
        default: '#fff'
      },
      type: {
        type: String,
        default: 'circular',
        validator (val) {
          return ['circular', 'spinner'].includes(val)
        }
      },
      size: {
        type: [Number, String],
        default: '30px'
      },
      textSize: {
        type: [Number, String],
        default: '14px'
      },
      textColor: {
        type: String,
        default: '#fff'
      },
      vertical: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        overlayStyle: {
          backgroundColor: 'rgba(0,0,0,0.3)'
        }
      }
    }
  }
</script>
